import styled from 'styled-components';
import { Section, MainTitle, Paragraf } from '../Styled';

export const UpperCta = styled(Section)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    & div {
      flex-basis: 100%;
      max-width: 100%;
    }
  }
`;

export const CtaCon = styled.div`
  flex-basis: 50%;
  max-width: 50%;
  flex-grow: 0;
  flex-shrink: 0;
`;

export const CtaLeft = styled(CtaCon)`
  flex-basis: 45%;
`;

export const CtaTitle = styled(MainTitle)`
&.white {
  color: ${({ theme }) => theme.mainColors.hvid};
}
@media screen and (max-width: 450px) {
  font-size: 1.5rem;
}
`

export const CtaPara = styled(Paragraf)`
&.white {
  color: ${({ theme }) => theme.mainColors.hvid};
}
`

export const Mockups = styled.img`
  display: block;
  margin: auto;
  max-width: 90%;
  min-width: 320px;
  object-fit: contain;
`;
